import { type } from 'arktype'

type GroupsCategoryMetadata = {
  visible: boolean
  displayName: string
  placeHolder: string
}

export const groupsCategoryIds = [
  'consultingServices',
  'construction',
  'wellnessBeauty',
  'restaurantsCoffee',
  'tech',
  'retailCraft',
  'securityTransport',
  'cultureMediaTourism',
] as const
export type GroupsCategory = (typeof groupsCategoryIds)[number]

export const groupsCategorySchema = type('===', ...groupsCategoryIds)

export function isGroupsCategory(value: string): value is GroupsCategory {
  return groupsCategorySchema.allows(value)
}

export const groupsCategories: Record<GroupsCategory, GroupsCategoryMetadata> = {
  consultingServices: {
    displayName: 'Conseil et services professionnels',
    visible: true,
    placeHolder: 'Agence de courtage en prêt...',
  },
  wellnessBeauty: {
    displayName: 'Bien-être, beauté et développement personnel',
    visible: true,
    placeHolder: 'Apithérapie...',
  },
  restaurantsCoffee: {
    displayName: 'Restaurants, bars et cafés',
    visible: true,
    placeHolder: 'Traiteur...',
  },
  tech: {
    displayName: 'Informatique et technologie',
    visible: true,
    placeHolder: 'Data engineer...',
  },
  retailCraft: {
    displayName: 'Commerce et artisanat',
    visible: true,
    placeHolder: 'Laverie automatique...',
  },
  securityTransport: {
    displayName: 'Sécurité et transport',
    visible: true,
    placeHolder: 'Télésurveillance...',
  },
  cultureMediaTourism: {
    displayName: 'Culture, média et tourisme',
    visible: true,
    placeHolder: 'Acteur/Comédien - hors cinéma et télévision...',
  },
  construction: {
    displayName: 'Construction et BTP',
    visible: true,
    placeHolder: 'Maçon...',
  },
}
